module.exports = __webpack_public_path__ + "static/media/Sub 18.ff101aee.jpg";